export class MgConflicts {
    values() {
        return [];
    }

    loaded() {
        return false;
    }
}